import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

//import pages
import Landing from './pages/landing/Landing';

const Routes = () => {
    return (
        <Router>
            <Switch>
                    <Route exact path="/" component={ Landing}/>
            </Switch>

        </Router>
    )
}

export default Routes
